import { render, staticRenderFns } from "./HealthcareExpensesAdd.vue?vue&type=template&id=050bba4e&scoped=true"
import script from "./HealthcareExpensesAdd.vue?vue&type=script&lang=ts"
export * from "./HealthcareExpensesAdd.vue?vue&type=script&lang=ts"
import style0 from "./HealthcareExpensesAdd.vue?vue&type=style&index=0&id=050bba4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050bba4e",
  null
  
)

export default component.exports